module.exports = __webpack_public_path__ + "static/media/left.fddcb8f3.jpg";